var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-body center-wrap"},[_c('div',{staticClass:"navBar cur-poi",on:{"click":function($event){return _vm.$nav.back()}}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" "+_vm._s(_vm.info.title)+" ")]),_c('div',{staticClass:"pad-20 txt-16",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }